import { v4 as uuidV4 } from "uuid";
import { AUTH_CLIENT_ID_LS_KEY } from "@anydo/core";

export function getClientId(storage: Storage): string {
  let clientId = storage.getItem(AUTH_CLIENT_ID_LS_KEY);

  if (clientId == null) {
    clientId = uuidV4();
    storage.setItem(AUTH_CLIENT_ID_LS_KEY, clientId);
  }

  return clientId;
}
